export const SubscriptionTypes = {
  Yearly: 1,
  Monthly: 2
}
